import { type AchievementKey, earnedAchievements } from '../domain/achievements';
import { WEEK_TARGET } from './schemas';
import { type DaySession, earliestDay } from './sessions';
import { deriveSummary } from './summary';

/**
 * The Account tab's numbers: everything the person has done, from their
 * own sessions. Unlike the shared summary this may count time — it never leaves the device
 * except as the person's own content.
 */
export interface MyStats {
  /** Days on which all three exercises were done ("Total sessions"). */
  sessionsTotal: number;
  bestStreak: number;
  currentStreak: number;
  sessionsThisMonth: number;
  /** Exercises completed, whole days or not ("Exercises done"). */
  exercisesDone: number;
  /** Seconds spent in completed exercises ("Total time"). */
  activeSeconds: number;
  /** Date of the first session — "Member since". Undefined before the first exercise. */
  memberSince: string | undefined;
  achievements: AchievementKey[];
}

export function deriveStats(sessions: readonly DaySession[], today: string): MyStats {
  const summary = deriveSummary(sessions, today);
  let exercisesDone = 0;
  let activeSeconds = 0;
  const memberSince = earliestDay(sessions);
  for (const session of sessions) {
    for (const attempt of session.attempts) {
      if (attempt.value.state !== 'done') continue;
      exercisesDone += 1;
      activeSeconds += attempt.value.activeSeconds;
    }
  }
  const sessionsTotal = summary.sessionsTotal ?? 0;
  return {
    sessionsTotal,
    bestStreak: summary.bestStreak,
    currentStreak: summary.currentStreak,
    sessionsThisMonth: summary.sessionsThisMonth,
    exercisesDone,
    activeSeconds,
    memberSince,
    achievements: earnedAchievements({
      sessionsTotal,
      target: WEEK_TARGET,
      completionByKind: summary.completionByKind,
      bestStreak: summary.bestStreak,
    }),
  };
}
